<template>

<app-panel v-on:close="$emit('close')" :loading="is.loading">
		
	<app-panel-title text="Launch session" />

	<app-panel-text>

		<p>You can access this convention as a real world administrator or attendee. Please note any action you take while logged in as another user will be actioned under their account.</p>

	</app-panel-text>

	<app-panel-content>

		<app-input-toggle :options="$util.options(typeOptions)" v-model="model.type" :full-width="true" />
		
		<app-input-toggle :options="$util.options(adminOptions)" v-model="model.user" :full-width="true" v-if="model.type === 1" />
		<app-input-toggle :options="$util.options(attendeeOptions)" v-model="model.user" :full-width="true" v-if="model.type === 2" />

		<app-input-suggest api="organisation/team/member" placeholder="Search users..." :params="{ organisation: organisation }" v-model="model.admin" v-if="model.type === 1 && model.user === 2" />
		<app-input-suggest api="convention/badge" placeholder="Search badges..." :params="{ convention: id }" v-model="model.attendee" v-if="model.type === 2 && model.user === 2" />

	</app-panel-content>

	<app-panel-content>

		<app-button text="Launch" :disabled="!isValid" :loading="is.saving" v-on:click="onConfirmClick" />

	</app-panel-content>

</app-panel>

</template>

<script>

export default {
	
	props: ['id', 'organisation'],

	data: function() {

		return {
			is: {
				loading: false,
				saving: false
			},
			model: {
				type: 1,
				user: 1,
				attendee: 0,
				admin: 0
			},
			typeOptions: {
				1: 'Admin',
				2: 'Attendee'
			},
			adminOptions: {
				1: 'Owner',
				2: 'Specific'
			},
			attendeeOptions: {
				1: 'Any',
				2: 'Specific'
			}
		}

	},

	computed: {
	
		isValid: function() {
		
			return (this.model.type === 1 && (this.model.user === 1 || this.model.admin)) || (this.model.type === 2 && (this.model.user === 1 || this.model.attendee))
		
		}

	},

	methods: {

		onConfirmClick: async function() {

			if(!this.isValid) return false

			this.is.saving = true

			var specific = (this.model.type === 1) ? this.model.admin : this.model.attendee

			this.$api.post('launch', {
				convention: this.id,
				mode: (this.model.type === 1) ? 'manager' : 'my',
				specific: (this.model.user === 1) ? false : specific
			}).then(function(json) {

				window.open(json.url)

				this.$emit('close')

			}.bind(this), function() {

				this.$notify({
					message: 'Failed to launch.',
					type: 'error'
				})

				this.is.saving = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

</style>
